/// <reference path="../Common/Helpers/LanguageList.ts" />
/// <reference path ="../Common/UserPreference/UserPreferenceStorage.ts" />

namespace TabAurous.ScriptInitialization {
    Q.Config.responsiveDialogs = true;
    Q.Config.rootNamespaces.push('TabAurous');
    Q.Config.rootNamespaces.push('_Ext');
    Q.Router.enabled = false;
    Serenity.EntityDialog.defaultLanguageList = LanguageList.getValue;
    Serenity.DataGrid.defaultPersistanceStorage = new TabAurous.Common.UserPreferenceStorage();
    Serenity.DateEditor.useFlatpickr = true; 

    //Serenity.setupUIOverrides();

    if ($.fn['colorbox']) {
        $.fn['colorbox'].settings.maxWidth = "95%";
        $.fn['colorbox'].settings.maxHeight = "95%";
    }

    window.onerror = Q.ErrorHandling.runtimeErrorHandler;

    Q.alert = (msg, opt: Q.AlertOptions) => {
        q.alert('Error!', msg, true, 6000);
    }

    Q.warning = (msg, opt: Q.AlertOptions) => {
        q.Alert('Warning!', msg, 4000, true);
    }

    Q.notifyWarning = (msg, title, opt: ToastrOptions) => {
        q.Alert('Warning!', msg, 4000, true);
    }

    Q.notifySuccess = (msg, title, opt?: ToastrOptions) => {
        q.success('', msg, 4000, true);
    }

    $(() => {
        
        var meta = $('meta[name=username]');
        if ((meta.length && meta.attr('content')) || (!meta.length && Q.Authorization.isLoggedIn)) {

            new Serenity.IdleTimeout({
                activityTimeout: 180 * 60,
                warningDuration: 2 * 60
            });
        }
    });

}